import React from 'react';
import { Checkbox, ConfigProvider } from 'antd';
import useDefaultTrebbleAntDTokenConfig from '../helper/useDefaultTrebbleAntDTokenConfig';

interface TrebbleCheckboxProps {
  useEditorTheme?: boolean;
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  autoFocus?: boolean;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  onChange?: (e: any) => void;
  onClick?: (e: React.MouseEvent) => void;
}

interface TrebbleCheckboxGroupProps {
  useEditorTheme?: boolean;
  defaultValue?: string[];
  disabled?: boolean;
  name?: string;
  options?: Array<string | { label: string; value: string; disabled?: boolean }>;
  value?: string[];
  className?: string;
  style?: React.CSSProperties;
  onChange?: (checkedValue: string[]) => void;
  children?: React.ReactNode;
}

const TrebbleCheckbox: React.FC<TrebbleCheckboxProps> & {
  Group: React.FC<TrebbleCheckboxGroupProps>;
} = ({ 
  useEditorTheme = false, 
  className = '',
  children,
  ...restProps 
}) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });
  
  const combinedClassName = `trebble-checkbox text-gray-900 dark:text-gray-100 ${className}`;

  return (
    <ConfigProvider theme={themeConfig}>
      <Checkbox 
        className={combinedClassName}
        {...restProps}
      >
        {children}
      </Checkbox>
    </ConfigProvider>
  );
};

const TrebbleCheckboxGroup: React.FC<TrebbleCheckboxGroupProps> = ({ 
  useEditorTheme = false, 
  className = '',
  children,
  ...restProps 
}) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });
  
  const combinedClassName = `trebble-checkbox-group text-gray-900 dark:text-gray-100 ${className}`;

  return (
    <ConfigProvider theme={themeConfig}>
      <Checkbox.Group 
        className={combinedClassName}
        {...restProps}
      >
        {children}
      </Checkbox.Group>
    </ConfigProvider>
  );
};

// Set display names
TrebbleCheckbox.displayName = 'TrebbleCheckbox';
TrebbleCheckboxGroup.displayName = 'TrebbleCheckbox.Group';

// Add Group property to TrebbleCheckbox
TrebbleCheckbox.Group = TrebbleCheckboxGroup;

export default TrebbleCheckbox; 